import type { Dictionary } from '@/features/i18n/dictionaries';
import type { AuthSurfaceViewModel } from '@/interfaces/AuthLogin';

type LoginSurfaceInput = {
    auth: Dictionary['auth'];
};

export const getAuthSurfaceViewModel = ({ auth }: LoginSurfaceInput): AuthSurfaceViewModel => {
    return {
        cardTitle: auth.loginTitle,
        cardDescription: auth.loginDescription,
    };
};
